<template>
    <div class="last-courses container mt-3">
        <h2 class="section-title"> اخر <span>الكورسات</span> </h2>
        <div class="courses-row">
            <div v-for="(item, index) in all_courses" :key="index" class="course-card">
                <img class="course-image" :src="item?.cover" :alt="item?.name">
                <div class="course-info">
                    <p class="course-name text-center fw-bold">{{ item?.name }}</p>
                    <template v-if="$store.state.userToken">
                        <template v-if="item?.has_subscription">
                            <router-link class="subscribe-btn" :to="{
                                name: 'course_content',
                                params: { id: item?.course_id },
                            }">
                                الدخول للكورس
                            </router-link>
                        </template>
                        <template v-else>
                            <div class="d-flex align-items-center gap-2">
                                <router-link class="subscribe-btn" :to="{
                                    name: 'payment',
                                    params: { id: item?.course_id },
                                    query: { free: item?.free },
                                }">اشترك الان</router-link>
                                <router-link class="subscribe-btn" :to="{
                                    name: 'course_content',
                                    params: { id: item?.course_id },
                                }">
                                    الدخول
                                </router-link>
                            </div>
                            <div v-if="item?.free == false" class="w-100 mt-2">
                                <button v-if="!is_activating" @click="activate_course_by_code(item?.course_id)"
                                    class="course-card-footer w-100">
                                    تفعيل الكورس بالكود
                                </button>
                                <button v-else disabled class="course-card-footer w-100">
                                    <span class="spinner-border"></span>
                                </button>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <router-link class="subscribe-btn" :to="{
                            name: 'payment',
                            params: { id: item?.course_id },
                            query: { free: item?.free },
                        }" v-if="!item?.has_subscription">اشترك الان</router-link>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import config from '@/services/config';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: 'HomeLastCoursesComponent',
    props: ['display_count'],
    data() {
        return {
            all_courses: [],
            is_loading: true ,
            is_activating: false
        }
    },
    methods: {
        get_all_courses() {
            axios.get(`${config.basURL}course/course-list`, {
                headers: {
                    auth: this.$store.state.userToken
                }
            }).then(res => {
                this.all_courses = this.display_count ? res.data.slice(0, this.display_count) : res.data
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.is_loading = false
            })
        },
        activate_course_by_code(course_id) {
            Swal.fire({
                title: "اكتب كود تفعيل الكورس",
                input: "text",
                imageUrl: this.data?.cover,
                imageHeight: "200",
                inputAttributes: {
                    autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: "تفعيل",
                cancelButtonText: "الغاء",
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    if (login == null || login.length == 0) {
                        Swal.fire({
                            text: "اكتب الكود عشان تعرف تفعل الكورس",
                            icon: "warning",
                        });
                        return;
                    }

                    this.is_activating = true;
                    axios
                        .post(
                            `${config.basURL}codes/active-course-code`,
                            {
                                course_id: course_id,
                                course_code: login,
                            },
                            {
                                headers: {
                                    auth: this.$store.state.userToken,
                                },
                            }
                        )
                        .then(() => {
                            Swal.fire({
                                text: "تم تفعيل الكورس بنجاح هتلاقي الكورس دلوقتي في كورساتي ",
                                icon: "success",
                            });
                            this.$router.push({ name: "user_courses" });
                        })
                        .catch((err) => {
                            console.log(err);
                            if (err.response.status == 400) {
                                Swal.fire({
                                    text: err.response.data.detail,
                                    icon: "error",
                                });
                            } else if (err.response.status == 404) {
                                Swal.fire({
                                    text: "الكود غلط اكتب الكود الصح ",
                                    icon: "error",
                                });
                            }
                            else {
                                Swal.fire({
                                    text: "حدث خطاء",
                                    icon: "error",
                                });
                            }
                        })
                        .finally(() => {
                            this.is_activating = false;
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
            });
        },
    },
    created() {
        this.get_all_courses()
    }
}
</script>
<style scoped>
.last-courses {
    padding: 2rem 0;
}

.last-courses .courses-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.last-courses .courses-row .course-card {
    width: calc(100% / 3 - 3rem);
    height: 475px;
    margin-bottom: 1rem;
    border-radius: 1rem;
    overflow: hidden;
    margin-left: 1rem;
    position: relative;
}

@media(max-width:767px) {
    .last-courses .courses-row .course-card {
        width: 100%;
        margin-right: 1rem;
    }
}

.last-courses .courses-row .course-card .course-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.last-courses .courses-row .course-info {
    min-height: 150px;
    padding: 1rem;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    background-color: #00000066;
    color: #fff;
    backdrop-filter: blur(50px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: translateY(100%);
    transition: all 0.5s ease;
    z-index: 3;
}

.last-courses .courses-row .course-card:hover .course-info {
    transform: translateY(0);
}

.section-title {
    font-weight: bold;
    margin: 2rem 0;
    text-align: center;
}

.section-title span {
    color: #f1c40f;
}

.subscribe-btn {
    background-color: #2b4239;
    color: #fff;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 700;
    text-decoration: none;
    width: 100%;
    min-height: 40px;
    transition: all 0.3s ease-in-out;
    text-align: center;
}

.subscribe-btn:hover {
    background-color: #dad2c5;
    color: #0d0d0d;
    transition: all 0.3s ease-in-out;
}

body.dark .section-title {
    color: #fff;
}

.course-card-footer {
    all: unset;
    padding: 0.5rem 0;
    text-align: center;
    cursor: pointer;
    background-color: #dad2c5;
    color: #000;
    border-radius: 5px;
}
</style>